import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/HeaderB";
import ProfileSidebar from "../components/ProfileSideBar";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const MainMenu = () => {
  const navigate = useNavigate();
  const { user, language } = useContext(AuthContext);

  const translations = {
    el: {
      welcome: "Καλώς ήρθες",
      viewDiscounts: "Προβολή προσφορών",
      addDiscount: "Νέα προσφορά",
    },
    en: {
      welcome: "Welcome",
      viewDiscounts: "View offers",
      addDiscount: "Add new offer",
    }
  };

  const t = translations[language] || translations.el;
  
  return (
    <div className="min-h-screen bg-custom-background flex flex-col">
      <Header /> {/* Header */}

      <main id="main-content" className="flex-1 flex flex-col items-center justify-center relative text-center px-4 md:px-8 py-10">
        <ProfileSidebar />

        {/* Main Content */}
        <h1 className="text-2xl md:text-3xl font-bold text-custom-letters mb-10">
          {t.welcome}, {user?.username || "User"}!
        </h1>

        <div id="menu-actions" className="flex flex-col md:flex-row gap-6">
          <button
            onClick={() => navigate("/discounts")}
            className="bg-gradient-to-r from-custom-grad1 via-custom-grad2 via-custom-grad3 to-custom-grad4 text-white font-semibold py-5 px-8 rounded-2xl shadow-md hover:scale-105 transition focus:outline-none focus:ring-4 focus:ring-custom-letters focus:ring-offset-2">
            {t.viewDiscounts}
          </button>

          <button
            onClick={() => navigate("/adddiscount")}
            className="bg-gradient-to-r from-custom-grad1 via-custom-grad2 via-custom-grad3 to-custom-grad4 text-white font-semibold py-5 px-8 rounded-2xl shadow-md hover:scale-105 transition focus:outline-none focus:ring-4 focus:ring-custom-letters focus:ring-offset-2">
            {t.addDiscount}
          </button>
        </div>
      </main>
    </div>
  );
};

export default MainMenu;
